import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'
import _imports_1 from '@/assets/file-upload-icon.svg'
import _imports_2 from '@/assets/paperclip-attachment.svg'
import _imports_3 from '@/assets/double-circle-radio-icon.svg'
import _imports_4 from '@/assets/circle-radio-icon.svg'
import _imports_5 from '@/assets/checkbox-checked.svg'


const _hoisted_1 = { class: "fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 transition-opacity duration-300 ease-in-out p-4" }
const _hoisted_2 = { class: "flex flex-col max-w-[628px] w-full h-fit p-6 mx-auto rounded-primary-radius bg-[#FFFFFF]" }
const _hoisted_3 = { class: "flex items-center justify-between pb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_4 = { class: "flex items-center justify-start gap-2" }
const _hoisted_5 = { class: "text-primary-text-color text-xl leading-[32px] font-semibold tracking-[0.01rem]" }
const _hoisted_6 = { class: "w-full h-[134px] flex items-center justify-center" }
const _hoisted_7 = {
  key: 0,
  for: "file",
  class: "w-full h-full mt-5 flex flex-col items-center justify-center border-dashed border-2 border-[#A7A5AE] rounded-primary-radius cursor-pointer"
}
const _hoisted_8 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-1" }
const _hoisted_9 = {
  key: 1,
  for: "file",
  class: "w-full h-full mt-5 flex flex-col items-center justify-center border-dashed border-2 border-[#393840] rounded-primary-radius cursor-pointer bg-[#F9F8F6]"
}
const _hoisted_10 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-1" }
const _hoisted_11 = { class: "mt-[24px]" }
const _hoisted_12 = { class: "text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790]" }
const _hoisted_13 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_14 = ["onChange", "checked"]
const _hoisted_15 = {
  src: _imports_3,
  alt: "Circle radio"
}
const _hoisted_16 = {
  src: _imports_4,
  alt: ""
}
const _hoisted_17 = { class: "pl-2 text-sm font-normal text-primary-text-color" }
const _hoisted_18 = { class: "mt-[24px]" }
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = ["disabled", "checked"]
const _hoisted_21 = { class: "w-full mt-4 pt-3 border-t border-black/15 flex items-start justify-end" }
const _hoisted_22 = {
  key: 0,
  class: "w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_23 = { key: 1 }

import client from "@/utils/axios";
import { errorToast, successToast } from "@/utils/custom-toast";
import { ref } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Emits = {
  (event: "close"): void;
  (event: "refresh"): void;
};

type Props = {
  termin: any;
  isSignedDocument: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateAbnahmeProtocolModal',
  props: {
    termin: {},
    isSignedDocument: { type: Boolean }
  },
  emits: ["close", "refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const { t } = useTranslate();

const radioButtons = ref([
  {
    id: "1",
    name: "radio1",
    text: "Vollabnahme",
  },
  {
    id: "2",
    name: "radio2",
    text: "Teilabnahme",
  },
]);

const radioValue = ref<string | null>(null);
const checkBoxValue = ref(props.isSignedDocument);
const uploadedFile = ref();
const isLoading = ref(false);

const onUpdateCheckboxValue = () => {
  checkBoxValue.value = !checkBoxValue.value;
};

const onUpdateRadioValue = (value: string) => {
  radioValue.value = value;
};

const handleFileChange = (event: any) => {
  if (event.target.files) {
    uploadedFile.value = Array.from(event.target.files)[0];
  }
};

const getFileType = (fileName: string) => {
  const match = fileName.match(/\.([0-9a-z]+)$/i);
  return match ? match[1].toLowerCase() : "";
};

const onSubmit = async () => {
  isLoading.value = true;

  if (uploadedFile.value && radioValue.value) {
    let fileType = getFileType(uploadedFile.value.name);
    const formData = new FormData();
    formData.append("question", radioValue.value);
    formData.append("isDocumentSigned", checkBoxValue.value + "");
    formData.append("extension", fileType);

    if (uploadedFile.value) {
      formData.append(`files[${0}]`, uploadedFile.value);
    }

    if (props.isSignedDocument) {
      await client.post(
        `/termin/${props.termin}/abnahmeprotokoll/signed-upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } else {
      await client.post(
        `/termin/${props.termin}/abnahmeprotokoll/manual-upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    isLoading.value = false;
    successToast("Successfully uploaded abnahmeprotokoll.");
    emits("refresh");
    emits("close");
  } else {
    isLoading.value = false;
    errorToast("Acceptance status and file are required.");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(t)("phase.upload_abnahmeprotokoll")), 1)
        ]),
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
          class: "cursor-pointer",
          src: _imports_0,
          alt: "Close icon"
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          (!uploadedFile.value)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("img", {
                  class: "w-7 h-7 object-cover",
                  src: _imports_1,
                  alt: "Attach icon"
                }, null, -1)),
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(t)("phase.choose_file")), 1)
              ]))
            : (_openBlock(), _createElementBlock("label", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  class: "w-7 h-7 object-cover",
                  src: _imports_2,
                  alt: "Attach icon"
                }, null, -1)),
                _createElementVNode("h4", _hoisted_10, _toDisplayString(uploadedFile.value.name), 1)
              ])),
          _createElementVNode("input", {
            class: "hidden",
            type: "file",
            id: "file",
            onChange: handleFileChange
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(t)("phase.acceptance_status")), 1),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radioButtons.value, (radio) => {
              return (_openBlock(), _createElementBlock("div", {
                key: radio.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["custom-radio-button flex items-center rounded-full py-[2px] px-2 border-2 cursor-pointer", 
                  radioValue.value === radio.text
                    ? 'bg-[#DDDDFB] border-transparent border-none'
                    : 'bg-transparent border-primary-text-color'
                ])
                }, [
                  _createElementVNode("input", {
                    onChange: ($event: any) => (onUpdateRadioValue(radio.text)),
                    type: "radio",
                    checked: radioValue.value === radio.text
                  }, null, 40, _hoisted_14),
                  _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
                    [_vShow, radioValue.value === radio.text]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                    [_vShow, radioValue.value !== radio.text]
                  ]),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(radio.text), 1)
                ], 2)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("input", {
              disabled: __props.isSignedDocument,
              onChange: onUpdateCheckboxValue,
              type: "checkbox",
              checked: checkBoxValue.value,
              class: _normalizeClass(checkBoxValue.value ? 'hidden' : 'block'),
              id: "updateAbnahmeProtocolCheckbox"
            }, null, 42, _hoisted_20),
            _withDirectives(_createElementVNode("img", {
              src: _imports_5,
              class: _normalizeClass(`${
                __props.isSignedDocument ? 'cursor-not-allowed' : 'cursor-pointer'
              }`),
              alt: ""
            }, null, 2), [
              [_vShow, checkBoxValue.value]
            ]),
            _createElementVNode("label", {
              class: _normalizeClass(["text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790]", `${
                __props.isSignedDocument ? 'cursor-not-allowed' : 'cursor-pointer'
              }`]),
              for: "updateAbnahmeProtocolCheckbox"
            }, _toDisplayString(_unref(t)("phase.signed_by_customer")), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            onClick: onSubmit,
            class: "w-[150px] flex justify-center text-base leading-[20px] tracking-[0.01rem] text-white font-semibold py-[13px] rounded-primary-radius bg-black disabled:bg-[#393840]/40 disabled:cursor-not-allowed"
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22))
              : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)("global.upload")), 1))
          ])
        ])
      ])
    ])
  ]))
}
}

})